(function () {
  'use strict';

  var io;
  function getObserver() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    return io;
  }

  function observeReveals(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.rv:not(.is-in)');
    var observer = getObserver();
    if (!observer) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  window.CA89 = window.CA89 || {};
  window.CA89.observeReveals = observeReveals;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeReveals(); });
  } else {
    observeReveals();
  }

  document.addEventListener('shopify:section:load', function (e) {
    observeReveals(e.target);
  });
})();
